var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeworksStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1535",
    "data-name": "Group 1535",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.813,
    height: 22.155,
    viewBox: "0 0 21.813 22.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 21.813,
    height: 22.155,
    fill: "#fa0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M.9,1.2C.8-.109,3,0,3,0V4H0L-3.76,2.708S-5.362.285-4.867,0L-.842-.21l-.5,1.677Z",
    transform: "translate(15.813 9.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M0-2.914,16,0V9H0Z",
    transform: "translate(2.813 11.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M.505,10.32A.823.823,0,0,1,.216,9.009L10.38.181c.151-.11.3-.248.5-.144l5.906,4.946.207-.281C17.758,3.349,18.417,1.89,19.2.551c.118-.2.247-.544.518-.549A2.634,2.634,0,0,1,21.41.712c.183.183.532.539.353.8l-2.915,5.4L21.23,8.987a.806.806,0,0,1,.047,1.113,1.2,1.2,0,0,1-.358.22H20.23v10.7a1.422,1.422,0,0,1-1.268,1.133l-16.368,0a1.433,1.433,0,0,1-1.4-1.225V10.32c-.2-.028-.5.038-.689,0m15.5.534,4.119-7.826c.018-.065-.056-.1-.1-.128-.29-.194-.693-.315-.971-.541C17.671,5,16.233,7.623,14.893,10.275Zm-5.647-.445a11.054,11.054,0,0,0-6.76,0v9.117a9.352,9.352,0,0,1,6.76,0Zm.756,0v9.117a9.355,9.355,0,0,1,6.716,0V10.454l-.756-.159c-.094.059-.567,1.107-.733,1.316a17.822,17.822,0,0,1-1.915,1.643c-.38.265-.707.158-.691-.333.027-.832.255-1.732.272-2.576l.219-.47a10.737,10.737,0,0,0-3.113.533",
    transform: "translate(0 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M211.091,289.746l3.681-.008a.365.365,0,0,1-.087.712c-1.082.125-2.4-.093-3.512,0a.37.37,0,0,1-.082-.7",
    transform: "translate(-198.346 -272.523)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M210.433,257.584l3.59-.007a.362.362,0,0,1,0,.711l-3.558,0a.36.36,0,0,1-.038-.7",
    transform: "translate(-197.687 -242.273)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M85.311,194.97a.621.621,0,0,1,.1.276,11.731,11.731,0,0,1,0,1.736c-.028.24-.15.314-.377.335-1.144.1-2.444-.083-3.606,0a.41.41,0,0,1-.31-.18c.01-.6-.093-1.349-.024-1.935a.343.343,0,0,1,.377-.335c1.133.082,2.4-.1,3.518,0a.606.606,0,0,1,.319.1",
    transform: "translate(-76.257 -183.259)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M85.395,290.033a.4.4,0,0,1-.321.655c-1.1-.089-2.391.12-3.469,0-.59-.065-.573-.7-.044-.756,1.132.078,2.4-.1,3.516,0a.605.605,0,0,1,.319.1",
    transform: "translate(-76.34 -272.673)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M81.518,258.333l3.813-.007a.358.358,0,0,1-.041.71c-1.137.132-2.526-.1-3.69,0a.368.368,0,0,1-.082-.7",
    transform: "translate(-76.467 -242.978)",
    fill: "#fa0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeworksStudent);
export default __webpack_public_path__ + "static/media/homeworks_student.f3cacd4ea85d3c9cd480d9ed5a4cf23d.svg";
export { ForwardRef as ReactComponent };